// extracted by mini-css-extract-plugin
export default {"tabBtn":"AddMenu_tabBtn__VCCc9","mainView":"AddMenu_mainView__xXs9F"};